import { useState } from 'react';
import { Link } from 'react-router-dom';
import './Soluciones.css';

const serviciosLista = [
  { 
    id: 1, 
    nombre: "Josemite: Control de Proyectos y Tareas", 
    img: "/images/josemitesolucion.jpg", 
    categoria: "web", 
    descripcion: "Simplifica la gestión de proyectos, organizando tareas de forma ágil y visual, con análisis de rentabilidad.",
    ruta: "/josemite-control-de-proyectos-y-tareas" 
  },
  { 
    id: 2, 
    nombre: "Entregas a Cuenta de Proveedores", 
    img: "/images/entregascuenta.jpg", 
    categoria: "addons", 
    descripcion: "Gestiona anticipos y facturas de entrega a cuenta de forma sencilla y automatizada en Sage 200.",
    ruta: "/entregas-cuenta-proveedores" 
  },
  { 
    id: 3, 
    nombre: "Gestor de Talleres", 
    img: "/images/gestiontalleres.jpg", 
    categoria: "addons", 
    descripcion: "Organiza y gestiona de forma eficiente los talleres y las reparaciones dentro de la empresa.",
    ruta: "/gestor-talleres" 
  },
  { 
    id: 4, 
    nombre: "Gestor de Transporte", 
    img: "/images/gestor_transporte.jpg", 
    categoria: "addons", 
    descripcion: "Optimiza la gestión de rutas, subcontrataciones y facturación en el transporte.",
    ruta: "/gestor-transporte" 
  },
  { 
    id: 5, 
    nombre: "Gestión de Partes de Trabajo", 
    img: "/images/gestion_partes.jpg", 
    categoria: "proximamente", 
    descripcion: "Permite registrar trabajos realizados de forma rápida y sencilla, asegurando que la información esté siempre actualizada.",
    ruta: "/gestion-de-partes" 
  },
  { 
    id: 6, 
    nombre: "Imputación de Proyectos", 
    img: "/images/imputacion_proyectos.jpg", 
    categoria: "proximamente", 
    descripcion: "Aplicación para registrar tareas y trabajo realizado en proyectos, centralizando la información operativa.",
    ruta: "/imputacion-de-proyectos" 
  },
  { 
    id: 7, 
    nombre: "Aplicación de Planta de Fabricación", 
    img: "/images/planta_fabricacion.jpg", 
    categoria: "proximamente", 
    descripcion: "Organiza y prioriza los trabajos pendientes, permitiendo imputar tiempos y consumos con facilidad para optimizar la producción.",
    ruta: "/aplicacion-planta-fabricacion" 
  },
  { 
    id: 8, 
    nombre: "SGA: Gestión de Almacén", 
    img: "/images/sga.jpg", 
    categoria: "proximamente", 
    descripcion: "Agiliza los procesos logísticos, mejorando la trazabilidad y reduciendo errores en la preparación y expedición de mercancías.",
    ruta: "/sga-gestion-de-almacen" 
  },
  { 
    id: 9, 
    nombre: "Gestor de Pedidos de Compra para Asociados", 
    img: "/images/gestor_pedidos.jpg", 
    categoria: "proximamente", 
    descripcion: "Conecta delegaciones de forma directa y eficiente, asegurando un flujo continuo de pedidos reflejados automáticamente en Sage 200.",
    ruta: "/gestor-pedidos-compra" 
  },
  { 
    id: 10, 
    nombre: "Gestión de Control Horario", 
    img: "/images/control_horario.jpg", 
    categoria: "proximamente", 
    descripcion: "Controla entradas y salidas, gestiona solicitudes de festivos y vacaciones, y registra incidencias de manera centralizada.",
    ruta: "/gestion-control-horario" 
  }
];

const filtros = ['todos', 'addons', 'web', 'app', 'proximamente'];

const Servicios = () => {
  const [filtro, setFiltro] = useState('todos');

  const serviciosFiltrados = filtro === 'todos' 
    ? serviciosLista 
    : serviciosLista.filter(servicio => servicio.categoria === filtro);

  return (
    <div className="servicios">
      {/* Imagen de fondo */}
      <div className="servicios-background">
        <img 
          src="/images/Solucionessbackground.jpg" 
          alt="Imagen de fondo de servicios"
          aria-hidden="true"
        />
      </div>

      {/* Capa semitransparente negra */}
      <div className="servicios-overlay"></div>

      <div className="servicios-container">
        <h1>Soluciones</h1>

        {/* Filtros */}
        <div className="filtros">
          {filtros.map((categoria) => (
            <button 
              key={categoria} 
              onClick={() => setFiltro(categoria)} 
              className={filtro === categoria ? 'activo' : ''}
            >
              {categoria.charAt(0).toUpperCase() + categoria.slice(1)}
            </button>
          ))}
        </div>

        {/* Lista de productos */}
        <div className="productos-grid">
          {serviciosFiltrados.map(servicio => (
            <div key={servicio.id} className="producto">
              <div className={`etiqueta ${servicio.categoria}`}>
                {servicio.categoria.toUpperCase()}
              </div>
              <img 
                src={servicio.img} 
                alt={servicio.nombre} 
                loading="lazy"
              />
              <h2>{servicio.nombre}</h2>
              <div className="descripcion">
                <p>{servicio.descripcion}</p>
              </div>
              <Link 
                to={servicio.ruta} 
                className="btn-mas-info"
              >
                Más información
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Servicios;
